import styles from "./RegisterFormGroup.module.css"; // Import correto do CSS
import { useEffect, useState } from "react";
import { Avatar, IconButton, Grid } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import HowToRegTwoToneIcon from "@mui/icons-material/HowToRegTwoTone";
import { FormGroupRegister } from "../formGrouRegister";
import { SectionContainer } from "../../../../components/SectionContainer/SectionContainer";
import { useClient } from "../../../../contexts/ClientContext";

interface RegisterFormsProps {
  expanded: boolean;
  // data?: ClientData; // Optional ClientData
  isUpdateMode: boolean;
  // onDataChange: (data: ClientData | undefined) => void;
}

export function RegisterFormGroup({ expanded, isUpdateMode }: RegisterFormsProps) {

  const registerClass = expanded ? styles.registerClientFormOpen : styles.registerClientFormClosed;
  const [spread, setSpread] = useState(expanded);
  // const [userData, setUserData] = useState<ClientData>({
  //   name: "",
  //   phone: "",
  //   email: "",
  //   cpf: "",
  //   cnpj: "",
  //   stateRegistration: "",
  //   stateRegistrationExempt: false,
  //   birthDate: "",
  //   addressId: null,
  //   deliveryAddressId: null,
  //   addressZipCode: "",
  //   addressStreet: "",
  //   addressNumber: "",
  //   addressComplement: "",
  //   addressDistrict: "",
  //   addressCity: "",
  //   addressState: "",
  //   deliveryAddressZipCode: "",
  //   deliveryAddressStreet: "",
  //   deliveryAddressNumber: "",
  //   deliveryAddressComplement: "",
  //   deliveryAddressDistrict: "",
  //   deliveryAddressCity: "",
  //   deliveryAddressState: "",
  //   createdAt: "",
  //   attendances: []
  // });

  const clientContext = useClient();

  useEffect(() => {
    setSpread(expanded)
  }, [expanded])

  useEffect(() => {
    if (clientContext.client.dadosPessoais.nome !== "") {
      setSpread(true);  // Expandir o formulário quando houver um cliente selecionado
    }
  }, [clientContext.client.dadosPessoais]);

  function toggleSpread() {
    setSpread(!spread);
  }

  return (
    <SectionContainer>
      <div className={`${registerClass}, ${styles.container}`}>
        <div className={styles.containerHeader}>
          <div className={styles.header}>
            <Avatar className={styles.avatarBackground}>
              <HowToRegTwoToneIcon />
            </Avatar>
            <Grid item xs={12} md={12} className={styles.clientAddressGroupTitle}>
              <h4>Dados de Cadastro</h4>
            </Grid>
          </div>
          {isUpdateMode && 
          <IconButton onClick={toggleSpread} className={styles.iconForClose}>
            {spread ? <ExpandLessIcon fontSize="large" />: <ExpandMoreIcon fontSize="large" />}
          </IconButton>
          }
        </div>
        {
          spread ?
            <FormGroupRegister isUpdateMode={isUpdateMode} /> :
              (
              <div className={styles.bottomTitle}>
              <p>{clientContext.client.dadosPessoais.nome || ""}</p>
              <p>{clientContext.client.dadosPessoais.email || ""}</p>
            </div>
            )
        }
        </div>
    </SectionContainer >
    // </div>
  );
}
